import React, { JSX } from 'react';
import { CalendarV2 } from '~/src/dash/components/calendar/CalendarV2';
import { INewCalDates } from '~/src/dash/components/calendar/CalendarV2/common';
import { IconV2 } from '~/src/dash/components/icons/IconV2';
import { Col, Cols, Text, spacing } from '~/src/dash/publicaUI';
import { LoadingState, LoadingStateLoading } from '~/src/dash/utils/loading-states';

interface IProps {
  calStartDate: moment.Moment;
  calEndDate: moment.Moment;
  isDisabled?: boolean;
  handleApplyDatesChange: ({ newStartDate, newEndDate }: INewCalDates) => void;
  loadState: LoadingState;
  campaignStartDate: moment.Moment;
  campaignEndDate: moment.Moment;
}

export const CampaignAuctionInsightsFilters = ({
  handleApplyDatesChange,
  campaignStartDate,
  campaignEndDate,
  calStartDate,
  calEndDate,
  isDisabled = false,
  loadState,
}: IProps): JSX.Element => {
  return (
    <Cols gap={spacing.large} style={{ justifyContent: 'flex-end', alignItems: 'center' }}>
      {/* LABEL */}
      <Col>
        <Cols gap={spacing.extraSmall} style={{ alignItems: 'center' }}>
          <Col displayFlex>
            <IconV2 name='calendar' small />
          </Col>
          <Col>
            <Text small bold tKey='Period' />
          </Col>
        </Cols>
      </Col>
      {/* Calendar */}
      <Col>
        <CalendarV2
          calStartDate={calStartDate}
          calEndDate={calEndDate}
          handleApplyDatesChange={handleApplyDatesChange}
          isDisabled={isDisabled || loadState === LoadingStateLoading}
          uniqueID='insightsCal'
          minDate={campaignStartDate}
          maxDate={campaignEndDate}
          customInitialVisibleMonth={() => calEndDate.clone().subtract(1, 'month')}
        />
      </Col>
    </Cols>
  );
};
